import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-shared-company-message', class extends Controller {
  static targets = ["content", "toggleText", "toggleIcon"]

  // トグルボタンクリック時の処理
  toggle() {
    const isExpanded = this.contentTarget.classList.contains('is-expanded')

    if (isExpanded) {
      // 折りたたむ
      this.contentTarget.classList.remove('is-expanded')
      this.toggleTextTarget.textContent = 'もっと見る'
      this.toggleIconTarget.textContent = '+'
    } else {
      // 展開する
      this.contentTarget.classList.add('is-expanded')
      this.toggleTextTarget.textContent = '閉じる'
      this.toggleIconTarget.textContent = '−'
    }
  }
})
